<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <blogBanner-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import blogBannerComponent from '../blog/blogBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'blogComponent',
  components: {
    headerComponent,
    blogBannerComponent,
    footerComponent,
  },
};
</script>
